import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { getData, postData } from 'src/utils/axios/serverHelper';

import { TQC1050_R01Dto } from './Dto_TQC1050_R01';

const baseUrl = `${config.apiUrl}/TQC1050_R01`;

export interface TQC1050_R01Params {
	compCd?: string;
	transportDt?: string;
	customCd?: string;
	brandCd?: string;
	inoutClass?: string;
	itemCd?: string;
	includeCompleted?: boolean;
	sortBy?: string;
}

/** 수입검사 대상(입고내역) 목록 조회 */
export const getTQC1050_R01List = async (option: string, params: TQC1050_R01Params) => {
	const url = option === 'search' ? `${baseUrl}/search` : baseUrl;
	return await getData<ResponseDto<TQC1050_R01Dto[]>>(url, { params });
};

/** 전체 건수 조회 */
export const getTQC1050_R01AllCount = async (params: TQC1050_R01Params) => {
	return await getData<ResponseDto<number>>(`${baseUrl}/allCount`, { params });
};

/** 검사결과 일괄 저장 */
export const saveTQC1050_R01 = async (list: TQC1050_R01Dto[]) => {
	return await postData<TQC1050_R01Dto[], ResponseDto<number>>(`${baseUrl}/save`, list);
};

/** 검사결과 삭제 (입고내역은 유지) */
export const deleteTQC1050_R01 = async (list: TQC1050_R01Dto[]) => {
	return await postData<TQC1050_R01Dto[], ResponseDto<number>>(`${baseUrl}/delete`, list);
};

/** 소재검사서 PDF — 브랜드별로 장이 나뉘며, 브랜드 없는 행은 제외된다 */
export const downloadReportPdf_TQC1050_R01 = async (params: TQC1050_R01Params) => {
	return await getData<Blob>(`${baseUrl}/report/pdf`, {
		params,
		responseType: 'blob',
		headers: { Accept: 'application/pdf' },
	});
};

/** 엑셀 다운로드 */
export const downloadExcel_TQC1050_R01 = async (params: TQC1050_R01Params) => {
	return await getData<ResponseDto<string>>(`${baseUrl}/excel`, { params });
};
